<script setup lang="ts">
import { ref, type Ref, watch, onMounted } from 'vue'
import { handleErr } from '@/composables/exception/handler'
import { CODE_OK } from '@/apis/code'
import { ElMessage, ElDialog } from 'element-plus'
import { renderMessage } from '@/utils/util'
import {
  checkCode,
  checkMobile,
  checkPassword,
  VAL_CODE_WRONG,
  VAL_MOBILE_INVALID,
  VAL_PASSWD_INVALID,
  VAL_PASSWD_INVALID_CHAR
} from '@/utils/validator'
import { currentLang } from '@/composables/settings/storage'
import { debounce } from 'perfect-debounce'
import type { CommonResponse } from '@/apis/api'
import { useI18n } from 'vue-i18n'
import { bindPhoneAndPassword, saveUserInfoDTO, type UserInfoDTO } from '@/composables/user/users'

const { t } = useI18n()

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['finish'])

const visible = ref(props.visible)

watch(
  () => props.visible,
  (newVal) => {
    visible.value = newVal
  }
)

onMounted(() => {
  console.log('BindPhoneDialog挂载结束')
})

let phone: Ref<string> = ref('')
let verifyCode: Ref<string> = ref('')
let passwd: Ref<string> = ref('')

const debouncedCallLogin = debounce(() => {
  preCommit()
}, 100)
async function preCommit() {
  phone.value = phone.value.trim()

  // phone
  const phoneValid = checkMobile(currentLang.value, phone.value)
  if (phoneValid == VAL_MOBILE_INVALID) {
    ElMessage({
      message: renderMessage(t('validate.wrong_phone')),
      type: 'warning'
    })
    return
  }

  // code
  const codeValid = checkCode(currentLang.value, verifyCode.value)
  if (codeValid == VAL_CODE_WRONG) {
    ElMessage({
      message: renderMessage(t('validate.wrong_code')),
      type: 'warning'
    })
    return
  }

  // password
  const passwdValid = checkPassword(passwd.value)
  console.log('checkpasswd', passwdValid)
  if (passwdValid == VAL_PASSWD_INVALID) {
    ElMessage({
      // message: '密码中必须至少包含字母和数字6-20位',
      message: renderMessage(t('validate.wrong_password')),
      type: 'warning'
    })
    return
  } else if (passwdValid === VAL_PASSWD_INVALID_CHAR) {
    ElMessage({
      // message: renderMessage(t('validate.invalid_char')),
      message: '密码中包含非法特殊符号，只允许: ~@#$%_-=.',
      type: 'error'
    })
    return
  }

  const { data, error, statusCode } = await bindPhoneAndPassword(phone.value, verifyCode.value, passwd.value)
  const resData = data as Ref<CommonResponse<UserInfoDTO>>
  if (error.value) {
    handleErr(resData, error, statusCode)
  } else {
    if (resData.value.code === CODE_OK) {
      const data = resData.value.data

      saveUserInfoDTO(data)
      ElMessage({
        message: t('register.bind_success'),
        type: 'success'
      })

      // 绑定成功
      setTimeout(() => {
        emit('finish', true)
      }, 500)
    } else {
      ElMessage({
        message: renderMessage(resData.value.message),
        type: 'warning'
      })
    }
  }
}

function sendCodeResult(result: string) {
  console.log(result)
}
</script>
<template>
  <el-dialog v-model="visible" :show-close="false" class="max-w-88 w-11/12 px-6" @close="emit('finish', false)">
    <template #header="{ close, titleId }">
      <div w-full flex="~ row" items-center>
        <h4 :id="titleId" grow text-lg>{{ $t('register.bind_phone_title') }}</h4>
        <RIcon icon="i-iconamoon:close-thin" @click="close"></RIcon>
      </div>
    </template>
    <form @submit.prevent="debouncedCallLogin">
      <div w-full flex="~ col">
        <input
          type="text"
          id="phone"
          name="phone"
          autocomplete="tel"
          maxlength="13"
          v-model="phone"
          input-base
          @keyup.enter.stop.prevent=""
          :placeholder="$t('register.phone')" />
        <div mt-3 flex flex-row>
          <input
            type="text"
            maxlength="6"
            v-model="verifyCode"
            class="min-w-5/10"
            mr-1.5
            grow
            input-base
            :placeholder="$t('register.varify_code')" />
          <!-- type 2 is login -->
          <SendVarifyCodeButton :phone="phone" :type="2" max-w-100 flex-none @sendResult="sendCodeResult" />
        </div>
        <input
          type="password"
          maxlength="18"
          v-model="passwd"
          mt-3
          input-base
          :placeholder="$t('register.password')"
          @keyup.enter.prevent="debouncedCallLogin" />
        <button mt-6 w-full rounded-2 btn-solid type="submit">
          {{ $t('register.bind_phone') }}
        </button>
      </div>
    </form>
  </el-dialog>
</template>
<style lang="scss" scoped></style>
